export default __webpack_public_path__ + "static/media/Dashboard-Active.094b03f9.svg";